<template>
  <button
      :disabled="disabled"
      @click="handleClick($event)"
      class="button transition-smooth"
      :class="[btnType, (disabled || loading) ? 'disabled' : '', small && 'small']"
  >
    <slot v-if="!loading" name="icon">
      <i class="fallback-icon" :class="icon"></i>
    </slot>
    <LoadingIcon v-if="loading" class="animate-spin"></LoadingIcon>
    <slot></slot>
  </button>
</template>

<script>
import BootstrapTypes from "../enums/BootstrapTypes";
export default {
  name: "Button.vue",
  emits: ['click'],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    href: {
      type: String,
      required: false,
    },
    outline: {
      type: Boolean,
      required: false,
    },
    type: {
      validator(value) {
        return Object.values(BootstrapTypes).includes(value);
      },
      default() {
        return BootstrapTypes.primary
      }
    }
  },
  computed: {
    btnType() {
      return 'button-' + (this.outline ? 'outline-' : '') +  this.type ;
    }
  },
  methods: {
    handleClick(event) {
      if (!this.loading){
        this.$emit('click', event);
      }
      if (this.href){
        this.navigator.navigatePath(this.href);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.small {
  padding: $spacing-xxs $spacing-xs;
  height: $spacing-xl;
}
.disabled {
  opacity: 0.5;
}
.animate-spin {
  animation: spin .8s ease-in-out infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
